import Dexie from 'dexie'

class SoundDB extends Dexie {
	constructor() {
		super('loadfetcher-sounds')
		this.version(1).stores({ sounds: 'id, savedAt' })
	}
}

const db = new SoundDB()

export const saveSound = r => db.sounds.put({ ...r, savedAt: Date.now() })
export const listSounds = () => db.sounds.toArray()
export const getSound = id => db.sounds.get(id).then(r => r || null)
export const deleteSound = id => db.sounds.delete(id)

export const DEFAULT_SOUNDS = [
	{ id: 258193, name: 'beep beep' },
	{ id: 337050, name: 'ping' },
	{ id: 634084, name: 'message alert' },
	{ id: 810191, name: 'notification chime' },
	{ id: 352655, name: 'piano notification' },
	{ id: 740423, name: 'message notification' },
	{ id: 361564, name: 'ding dong' },
	{ id: 573381, name: 'ding' },
	{ id: 439447, name: 'soft chime' },
	{ id: 337168, name: 'alarm' },
	{ id: 362208, name: 'horn' },
	{ id: 836905, name: 'bell' },
	{ id: 762106, name: 'soft accept' },
	{ id: 413749, name: 'confirmation' },
	{ id: 762107, name: 'piano alert' },
	{ id: 269152, name: 'metallic alert' },
	{ id: 72129, name: 'sweet alert' },
	{ id: 762115, name: 'quick alert' },
	{ id: 762110, name: 'cancel back' },
	{ id: 338148, name: 'ding sharp' },
]
